import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'notice',
  name: '公告',
  icon: '告',
  group: '基础组件',
  description: '展示滚动或静态公告',
  defaultProps: {
    text: '公告内容',
    icon: 'bell',
    scrollable: true,
    closable: false
  }
}
